module.exports = __webpack_public_path__ + "img/inflated.6188bfd9.svg";